module.exports = __webpack_public_path__ + "img/wt7.6fb2f312.png";